import ProfileAdd from "./ProfileAdd";
import { SocialIcon } from "../utils/social-icon";
import { XIcon } from "../shared-components/icons";
import { useState, useEffect } from "react";
import { ItemWithMetaData } from "../api/Items";
import { useValidateProfile } from "../api/ProfilesApi";
import { profileUrlsMatch } from "../utils/personFieldLimits";

type ManualAddProfilesQAProps = {
  existingProfiles: ItemWithMetaData[];
  setNewProfiles: (newProfiles: string[]) => void;
};

export const ManualAddProfilesQA = ({
  existingProfiles,
  setNewProfiles,
}: ManualAddProfilesQAProps) => {
  const [profileAddList, setProfileAddList] = useState<string[]>([]);

  const {
    mutateAsync: validateProfileAsync,
    isLoading: validateProfileLoading,
  } = useValidateProfile();
  useEffect(() => {
    setNewProfiles(profileAddList || []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileAddList]);

  function urlInExistingProfiles(url: string) {
    return existingProfiles.some((profile) =>
      profileUrlsMatch(profile.item.content?.url ?? "", url)
    );
  }

  function handleAddProfile(inputUrl: string) {
    setProfileAddList((prev) => [inputUrl, ...prev]);
  }

  async function handleValidateProfile(inputUrl: string): Promise<string> {
    if (urlInExistingProfiles(inputUrl)) {
      return "This profile already exists";
    }
    if (
      profileAddList.some((existing) => profileUrlsMatch(existing, inputUrl))
    ) {
      return "This profile is already being added";
    }
    try {
      const response = await validateProfileAsync(inputUrl);
      return response.valid ? "" : response.error || "Validation failed";
    } catch {
      return "";
    }
  }

  function handleRemoveProfile(index: number, existing: string[]) {
    setProfileAddList(existing.filter((_, i) => i !== index));
    return;
  }

  return (
    <div className="mt-4">
      <div className="mx-auto bg-gray-50 rounded-lg p-4">
        <div className="font-semibold pb-4">Manually Add Profiles</div>
        <div>
          <ProfileAdd
            handleAddProfile={handleAddProfile}
            validateProfile={handleValidateProfile}
            isValidating={validateProfileLoading}
          />
        </div>
        {profileAddList && profileAddList.length > 0 && (
          <>
            <div className="block h-1 border-solid border-t-2 mt-5"></div>
            <div className="border-black">
              {profileAddList.map((url: string, index: number) => (
                <div className="bg-white my-3" key={index}>
                  <div className="border rounded-lg p-1 pr-4">
                    <div className="flex w-full items-center">
                      <div className="w-19">
                        <SocialIcon
                          url={url}
                          className="pointer-events-none"
                          style={{ width: "45px", height: "45px" }}
                        />
                      </div>
                      <div className="flex-1 truncate pl-2">{url}</div>
                      <div className="px-5 ml-auto">
                        <button
                          onClick={() => {
                            handleRemoveProfile(index, profileAddList);
                          }}
                        >
                          <XIcon />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
